export default "__VITE_ASSET__DnOH9aI6__"